export default "__VITE_ASSET__Bqn9hrLk__"